import { EINVerificationFailiureContainer } from 'src/containers';

export const EINVerificationFailed = () => <EINVerificationFailiureContainer />;
